var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1H5C4.60268 1.00165 4.22211 1.16021 3.94116 1.44116C3.66021 1.72211 3.50165 2.10268 3.5 2.5V13.5C3.50165 13.8973 3.66021 14.2779 3.94116 14.5588C4.22211 14.8398 4.60268 14.9984 5 15H11C11.3973 14.9984 11.7779 14.8398 12.0588 14.5588C12.3398 14.2779 12.4984 13.8973 12.5 13.5V2.5C12.4984 2.10268 12.3398 1.72211 12.0588 1.44116C11.7779 1.16021 11.3973 1.00165 11 1ZM5 2H11C11.1326 2 11.2598 2.05268 11.3536 2.14645C11.4473 2.24021 11.5 2.36739 11.5 2.5V3H4.5V2.5C4.5 2.36739 4.55268 2.24021 4.64645 2.14645C4.74021 2.05268 4.86739 2 5 2ZM11 14H5C4.86739 14 4.74021 13.9473 4.64645 13.8536C4.55268 13.7598 4.5 13.6326 4.5 13.5V13H11.5V13.5C11.5 13.6326 11.4473 13.7598 11.3536 13.8536C11.2598 13.9473 11.1326 14 11 14Z",
    fill: "#A1342D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.f98878ff23e3314e9e6abe07fe7456ca.svg";
export { ForwardRef as ReactComponent };